package com.essntl.uikit.components.link

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun NavLinkDivider() {
    Text(
        text = "/",
        style = MaterialTheme.esTypography.p2Regular14,
        color = MaterialTheme.esColorScheme.textTertiary,
    )
}